module.exports = __webpack_public_path__ + "static/media/background_first_page_1080p.8a0d964e.jpg";